import React__default from 'react';
import { SvgImg } from '../../components/svgImg/svgImg.js';

const StepFour = ({ width = '49', height = '40' }) => (React__default.createElement(SvgImg, { width: width, height: height, viewbox: "0 0 53 40", fill: "none", title: 'stepFour' },
    React__default.createElement("circle", { cx: "33", cy: "20", r: "20", fill: "#FFF0F0" }),
    React__default.createElement("path", { d: "M11.8999 6.65H11.7076L11.6045 6.81235L0.704554 23.9739L0.65 24.0598V24.1616V28.5679V28.9179H1H12.6322V33.67V34.02H12.9822H19.2438H19.5938V33.67V28.9179H22.4133H22.7633V28.5679V23.3885V23.0385H22.4133H19.5938V7V6.65H19.2438H11.8999ZM12.6322 15.559V23.0385H7.93351L12.6322 15.559Z", fill: "white", stroke: "#BF0000", strokeWidth: "0.7" })));

export { StepFour };
